
export const sorting = [
  { title: 'Best Match', slug: 'best-match'},
  { title: 'Price: Highest first', slug: 'price-desc'},
  { title: 'Price: Lowest first', slug: 'price-asc'},
  { title: 'Length: Highest first', slug: 'length-desc'},
  { title: 'Length: Lowest first', slug: 'length-asc'},
  { title: 'Width: Highest first', slug: 'width-desc'},
  { title: 'Width: Lowest first', slug: 'width-asc'}
]
